import { useState } from 'react'
import {
  Backdrop,
  Box,
  BoxProps,
  Container,
  Fade,
  IconButton,
  Modal,
  Stack,
  SvgIcon,
  Typography
} from '@mui/material'

import Button from '@/components/base/button'

import { WPLink } from '@/types'

export type ModalProps = {
  title: string
  text: string
  actions: {
    title: string
    button: WPLink
  }
}

export type ModalDevProps = BoxProps & Partial<{ modal: ModalProps }>

const ModalDev = ({ modal, ...props }: ModalDevProps) => {
  const [open, setOpen] = useState(false)
  const handleOpen = () => setOpen(true)
  const handleClose = () => setOpen(false)

  return (
    <Box {...props}>
      <Container>
        <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
          <Button onClick={handleOpen}>Open Modal</Button>
        </Box>
      </Container>

      <Modal
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        open={open}
        onClose={handleClose}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: {
            timeout: 500
          }
        }}
      >
        <Fade in={open}>
          <Box
            sx={{
              display: 'grid',
              position: 'relative',
              margin: 'auto',
              gap: 6,
              padding: 4,
              maxWidth: '67.2rem',
              backgroundColor: 'surface.background',
              borderRadius: (theme) => theme.shape.borderRadius4
            }}
          >
            <Box sx={{ display: 'grid', gap: 2 }}>
              <Stack direction="row" justifyContent="space-between" alignItems="center">
                <Typography id="modal-modal-title" variant="h4" color="text.secondaryContrastText">
                  {modal?.title}
                </Typography>
                <IconButton size="medium" color="secondary" onClick={handleClose}>
                  <SvgIcon fontSize="medium">
                    <use href="#ico-close" />
                  </SvgIcon>
                </IconButton>
              </Stack>
              <Typography id="modal-modal-description" variant="textRegular" color="text.primary">
                {modal?.text}
              </Typography>
            </Box>

            <Box sx={{ display: 'grid', gap: 2 }}>
              <Typography
                id="modal-modal-title"
                variant="textLarge"
                color="text.secondaryContrastText"
                fontWeight="500"
              >
                Accedi per contattare l’offerente:
              </Typography>

              <Box>
                <Button icon="user">Accedi</Button>
              </Box>
            </Box>
          </Box>
        </Fade>
      </Modal>
    </Box>
  )
}

export default ModalDev
